import script from "./FilaModificarGrupo.vue?vue&type=script&setup=true&lang=js"
export * from "./FilaModificarGrupo.vue?vue&type=script&setup=true&lang=js"

import "./FilaModificarGrupo.vue?vue&type=style&index=0&id=d66ece24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d66ece24"]])

export default __exports__